/**
 * @file Manages the fonts values for the theme Modern V1.
 * @author kkumari
 */export default {
  FONT_CORMORANT_MEDIUM: 'CormorantMedium, serif',
  FONT_CORMORANT_REGULAR: 'CormorantRegular, serif',
  FONT_MONTSERRAT_SEMI_BOLD: 'MontserratSemiBold, serif',
  FONT_MONTSERRAT_MEDIUM: 'MontserratMedium, serif',
  FONT_SIZE_BASE: '16px',
  FONT_SIZE_SMALL: '10px',
  FONT_SIZE_DEFAULT: '14px',
  FONT_LETTER_SPACING_DEFAULT: '1.4px',
  FONT_LINE_HEIGHT_DEFAULT: '18px',
  FONT_ICONS: 'Arial, sans-serif',
  FONT_WEIGHT_BOLD: 'bold',
  FONT_WEIGHT_NORMAL: 'normal',
  FONT_WEIGHT_600: '600',
  FONT_WEIGHT_500: '500',
  FONT_WEIGHT_300: '300',
  //Mobile values
  //H1
  FONT_SIZE_H1: '36px',
  LINE_HEIGHT_H1: '40px',
  LETTER_SPACING_H1: 'normal',
  //H2
  FONT_SIZE_H2: '30px',
  LINE_HEIGHT_H2: '37px',
  LETTER_SPACING_H2: 'normal',
  //H3
  FONT_SIZE_H3: '24px',
  LINE_HEIGHT_H3: '26px',
  LETTER_SPACING_H3: '1.5px',
  //H4
  FONT_SIZE_H4: '15px',
  LINE_HEIGHT_H4: '26px',
  LETTER_SPACING_H4: '1.5px',
  //H5
  FONT_SIZE_H5: '12px',
  LINE_HEIGHT_H5: '20px',
  LETTER_SPACING_H5: '0.12px',
  //P
  FONT_SIZE_P: '16px',
  LINE_HEIGHT_P: '24px',
  LETTER_SPACING_P: '0.32px',
  DESKTOP: {
    //Desktop values
    //H1
    FONT_SIZE_H1: '64px',
    LINE_HEIGHT_H1: '70px',
    LETTER_SPACING_H1: 'normal',
    //H2
    FONT_SIZE_H2: '42px',
    LINE_HEIGHT_H2: '46px',
    LETTER_SPACING_H2: 'normal',
    //H3
    FONT_SIZE_H3: '30px',
    LINE_HEIGHT_H3: '36px',
    LETTER_SPACING_H3: 'normal',
    //H4
    FONT_SIZE_H4: '14px',
    LINE_HEIGHT_H4: '18px',
    LETTER_SPACING_H4: '1.4px',
    //H5
    FONT_SIZE_H5: '12px',
    LINE_HEIGHT_H5: '15px',
    LETTER_SPACING_H5: '0.12px',
    //P
    FONT_SIZE_P: '17px',
    LINE_HEIGHT_P: '27px',
    LETTER_SPACING_P: 'normal'
  },
  FONT_FACES: ['CormorantMedium', 'MontserratSemiBold', 'CormorantRegular', 'MontserratMedium']
};